import styled from "styled-components"
import { animated } from "@react-spring/web"
import { colours } from "../../../ApartmentFinderConfig/colours"

export const UI = styled(animated.div)`
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  -webkit-touch-callout: none;
  background-color: ${colours.primaryUI};
  overflow: hidden;
  z-index: 1000;
  position: absolute;
  margin: 0;
  padding-top: 9%;
  right: 0;
  top: ${props => props.right}px;
  overflow: scroll;
  width: 25vw;
  height: 99.99vh;
  opacity: 0.88;
  display: block;
  justify-content: center;
  align-items: center;
`

export const TitleHolder = styled.div`
  padding: 4% 4%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  text-align: right;
  /* overflow: hidden; */
  height: 100%;
  width: 50%;
  user-select: none;

  h1 {
    line-height: 0px;
    flex: 1;
    color: ${colours.offWhite};
    font-family: NotoSans-Regular;
    font-size: 1.45rem;
  }
  h2 {
    flex: 1;
    color: ${colours.primaryUI};
    font-family: lora;
    font-size: 1.2rem;
  }

  h3 {
    line-height: 0px;
    flex: 1;

    color: ${colours.primaryUI};
    font-size: 0.75rem;
    font-family: NotoSans-Regular;
  }
`
export const IconHolder2 = styled.div`
  padding: 4%;
  height: 100%;
  width: 50%;
`
export const TempFaves = styled.div`
  display: flex;
  cursor: pointer;
  border-bottom: ${colours.offWhite} solid 4px;
  opacity: 1;
  margin: 0.1% 0%;
  height: 13vh;
  color: white;
  font-size: 3rem;
`

export const MainContent = styled.div`
  background-color: ${colours.secondaryUI};
  flex: 5;
  display: flex;
`

export const SubContent = styled.div`
  background-color: ${colours.primaryUILighter};
  flex-grow: 1;
`

export const IconHolder = styled.div`
  z-index: 4000000;
  user-select: none;
  position: absolute;
  cursor: pointer;
  top: 0%;
  right: 0%;
  height: 60px;
  width: 60px;
  margin: 2%;
`
